import React from "react";
import "./admin/BackendLayout.css"
import {Header, Sidebar, Footer} from "./admin";
import {Breadcrumb, ErrorMessageAlert} from "../components";
import _ from 'lodash';
import {useSelector} from 'react-redux';
import LoadingSpinner from "../components/loading/LoadingSpinner";

const UserMasterLayout = (props) => {
  const {breadcrumb, page = '', children} = props;
  const sidebar = useSelector(state => state.page_settings.sidebar);
  let hasSidebar = _.isEmpty(sidebar) ? false : true;
  let hasBreadcrumb = _.isEmpty(breadcrumb) ? false : true;
  let container = (page === 'top') ? 'w-full' : 'page-content-container flex-grow';
  const loading = useSelector((s) => s.loading);
  return (
    <div className="w-full flex flex-col">
      <Header app="users"/>
      <div className="relative">
        <LoadingSpinner />
        <main id="view-main" className={`flex-none flex flex-row main-container overflow-x-auto !min-h-screen ${loading.isLoading ? 'invisible' : ''}`}>
          {hasSidebar && <Sidebar app="user-master" sidebar={sidebar}/>}
          <div className={`${container}  px-6 pt-2`}>
          {/* Content Container */}
          <div className="page-container">
            {hasBreadcrumb && <Breadcrumb breadcrumb={breadcrumb} />}
            {children}
          </div>
          <Footer />
        </div>
        </main>
      </div>
    </div>
  );
};

export default UserMasterLayout;
